import { Controller } from "@hotwired/stimulus"

// The profile's feed and its address. Chat is not one of
// them: it is the panel beside the page (profile_chat_panel_controller), and
// its address (/u/:slug/messages) is the feed with that panel open.
export default class extends Controller {
  static targets = ["panel", "breadcrumb", "child", "sectionTitle"]
  static values = { active: String, chatUrl: String, section: String }

  connect() {
    this.show(this.activeValue === "messages" ? "feed" : (this.activeValue || "feed"))
    this._popState = () => {
      const url = new URL(location.href)
      const chat = url.pathname === new URL(this.chatUrlValue, location.href).pathname
      const tab = chat ? "messages" : "feed"
      this.show(chat ? "feed" : tab)
      this.notify(tab)
    }
    window.addEventListener("popstate", this._popState)
  }

  disconnect() { window.removeEventListener("popstate", this._popState) }

  openChat() {
    this._chatPanel()?.open()
  }

  _chatPanel() {
    return this.application.getControllerForElementAndIdentifier(this.element, "profile-chat-panel")
  }

  openTwin(event) {
    const host = this.element.querySelector("[data-controller~='profile-stage']")
    this.application.getControllerForElementAndIdentifier(host, "profile-stage")?.openStage(event)
  }

  // The owner's "Play all animations": every clip, once each, on the stage.
  demoTwin(event) {
    const host = this.element.querySelector("[data-controller~='profile-stage']")
    this.application.getControllerForElementAndIdentifier(host, "profile-stage")?.demo(event)
  }

  show(tab) {
    this.activeValue = tab
    const main = this.element.querySelector(".profile-home-main")
    if (main) main.dataset.profileNavigationActiveValue = tab
    this.panelTargets.forEach(panel => { panel.hidden = panel.dataset.tab !== tab })
    this.childTarget.hidden = tab === "feed" && !this.sectionValue
    this.sectionTitleTarget.textContent = this.sectionValue
  }

  navigate(path) {
    const url = new URL(path, location.href)
    if (url.pathname + url.search !== location.pathname + location.search) history.pushState({}, "", url)
  }

  notify(tab) {
    this.element.dispatchEvent(new CustomEvent("profile-navigation:history", { bubbles: true, detail: { tab } }))
  }
}
